import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  
  constructor(private GenericUtility: GenericUtilityService, private http: HttpClient) { }

  getPatientInfoReferralFlow(url: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetGeneralPatientReferralInformation?url=" + url);
  }


  GetPatientSelectedReferral(patientAccount: any, practiceCode: any,referralId:any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetPatientSelectedReferral?PatientAccount=" + patientAccount + '&PracticeCode=' + practiceCode + '&ReferralId=' + referralId);
  }

  AddPatientReferral(addreferralmodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "AddUpdatePatientReferral", addreferralmodel);
  }

  printReferralLog(PatientAccount: any, PracticeCode: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/PrintReferralLog?PatientAccount=" + PatientAccount + '&PracticeCode=' + PracticeCode);
  }
  searchProviderByNPI(dto: any) {
    var param = "";
    if (dto.FirstName) {
      param += "&FirstName=" + dto.FirstName;
    }
    if (dto.LastName) {
      param += "&LastName=" + dto.LastName;
    }
    if (dto.Number) {
      param += "&Number=" + dto.Number;
    }

    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetProviderSearch_Breeze?PatientAccount=" + dto.PatientAccount + param + '&City=' + dto.City + '&State=' + dto.State + '&PostalCode=' + dto.Zip + '&TaxonomyDescription=' + dto.TaxonomyDescription + '&Limit=' + '50');
  }

  GetPatientReferralDetails(patientAccount: any, practiceCode: any, referralid:any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetPatientReferralDetails?PatientAccount=" + patientAccount + '&PracticeCode=' + practiceCode + '&ReferralID=' + referralid);
  }

  ProviderSearch(searchProvidermodel: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "ProviderSearch", searchProvidermodel);
  }

  GetAllSpeciality(patientAccount: any, practiceCode: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetAllSpeciality?PatientAccount=" + patientAccount + '&PracticeCode=' + practiceCode);
  }





}
